import { Navigate, Route, Routes } from "react-router-dom";
import {
  AuthProvider,
  Login,
  MainLayout,
  NotificationProvider,
  Profile,
} from "@vionixasia/shared-components";
import DashboardPage from "./app/dashboard/page";
import DashboardOverviewPage from "./app/dashboard/overview/page";
import NewProjectPage from "./app/dashboard/projects/new/page";
import ProjectPage from "./app/dashboard/project/page";
import NewEventPage from "./app/dashboard/event/new/page";
import EventPage from "./app/dashboard/event/page";
import ImportPage from "./app/dashboard/import/page";
import ResultsPage from "./app/dashboard/results/page";
import WhatsAppLogsPage from "./app/dashboard/whatsapp-logs/page";
import InboxPage from "./app/dashboard/inbox/page";
import ThreadPage from "./app/dashboard/thread/page";
import PublicResultViewPage from "./app/results/view/page";

const menuItems = [
  { label: "Dashboard", to: "/dashboard/overview" },
  { label: "Projects", to: "/dashboard/projects" },
  { label: "Profile", to: "/profile" },
];

const NotFound = () => (
  <section className="flex min-h-[60vh] w-full flex-col items-center justify-center bg-white px-4 text-center text-slate-700">
    <h1 className="text-3xl font-semibold">Page not found</h1>
    <p className="mt-2 text-sm text-slate-500">Halaman yang dicari tidak tersedia.</p>
  </section>
);

export default function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <MainLayout appName="WHATSAPP" menuItems={menuItems} className="bg-white" showFooter>
          <Routes>
            <Route index element={<Navigate to="/dashboard/overview" replace />} />
            <Route path="login" element={<Login />} />
            <Route path="profile" element={<Profile />} />
            <Route path="Profile" element={<Profile />} />
            <Route path="dashboard" element={<Navigate to="/dashboard/overview" replace />} />
            <Route path="dashboard/overview" element={<DashboardOverviewPage />} />
            <Route path="dashboard/projects" element={<DashboardPage />} />
            <Route path="dashboard/projects/new" element={<NewProjectPage />} />
            <Route path="dashboard/project" element={<ProjectPage />} />
            <Route path="dashboard/event/new" element={<NewEventPage />} />
            <Route path="dashboard/event" element={<EventPage />} />
            <Route path="dashboard/import" element={<ImportPage />} />
            <Route path="dashboard/results" element={<ResultsPage />} />
            <Route path="dashboard/whatsapp-logs" element={<WhatsAppLogsPage />} />
            <Route path="dashboard/inbox" element={<InboxPage />} />
            <Route path="dashboard/thread" element={<ThreadPage />} />
            <Route path="results/view" element={<PublicResultViewPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </MainLayout>
      </NotificationProvider>
    </AuthProvider>
  );
}
